<template>
  <router-view />
</template>

<script>

export default {
  name: 'app',
  components: {
  },
  data() {
    return {
    }
  }
}
</script>


<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  html, body {
    margin:0;
    padding:0;
    background-color: #000;
  }
</style>
